const voiceLive = {
  // 直播模式主持人麦位展示
  liveEmceeMic: `/authApi/voice/v1/liveEmceeMic`,
  // 直播模式控放麦
  liveMicControl: `/authApi/voice/v1/liveMicControl`,
  // 直播模式麦序调整-移除
  liveMicIndexAdjust: `/authApi/voice/v2/liveMicIndexAdjust`,
  // 直播模式主持人上下麦
  liveEmceeMicOperate: `/authApi/voice/v1/liveEmceeMicOperate`,
  // 直播模式麦序列表
  liveMicList: `/authApi/voice/v1/liveMicList`,
  // 直播模式上下麦
  liveMicOperate: `/authApi/voice/v1/liveMicOperate`,
  // 直播模式停止上下麦
  liveMicStop: `/authApi/voice/v1/liveMicStop`,
  // 直播模式房间信息
  liveModelInfo: `/authApi/voice/v1/liveModelInfo`,
  // 保存语音房间设置数据
  saveVoiceRoomSetting: `/liveApi/api/v3/Anchor/saveVoiceRoomSetting`,
  // 获取语音房间设置数据
  getVoiceRoomSetting: `/liveApi/api/v3/Anchor/getVoiceRoomSetting`,
  // 禁言操作
  banOperate: `/authApi/voice/v1/banOperate`,
  // 提出操作
  kickOut: `/authApi/voice/v1/kickOut`,
  // 直播模式首麦人员视频开关
  liveFirstMicVideoSwitch: `/authApi/voice/v1/liveFirstMicVideoSwitch`
};

export default voiceLive;
